module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "wrapper",
    attrs: {
      "id": "wrapper_main"
    }
  }, [_c('div', {
    staticClass: "addr_list"
  }, [_c('ul', {
    staticClass: "addrShow"
  }, _vm._l((_vm.addrList), function(ali, index) {
    return _c('li', {
      staticClass: "unit",
      on: {
        "click": function($event) {
          _vm.useIt(ali.id)
        }
      }
    }, [_c('div', {
      staticClass: "inner"
    }, [_c('span', {
      staticClass: "choose_btn",
      class: [ali.isDefault == 0 ? 'unchoose' : 'choose']
    }), _vm._v(" "), _c('div', {
      staticClass: "adrl_list inner_msg"
    }, [_c('p', [_c('span', {
      staticClass: "nick_name"
    }, [_vm._v(_vm._s(ali.addressUser))]), _vm._v(" "), _c('span', {
      staticClass: "adrl_phone"
    }, [_vm._v(_vm._s(ali.addressPhone))]), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (ali.isDefault),
        expression: "ali.isDefault"
      }],
      staticClass: "default_note"
    }, [_vm._v("默认")])]), _vm._v(" "), _c('p', {
      staticClass: "add_detail"
    }, [_vm._v(_vm._s(ali.addressStreet))])]), _vm._v(" "), _c('div', {
      staticClass: "addr_msg",
      staticStyle: {
        "display": "none"
      }
    }), _vm._v(" "), _c('a', {
      attrs: {
        "href": "#/addaddr"
      },
      on: {
        "click": function($event) {
          _vm.modthis(ali.id)
        }
      }
    }, [_c('span', {
      staticClass: "edit_btn"
    })])])])
  }))]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isMaskShow),
      expression: "isMaskShow"
    }],
    staticClass: "windowDrive"
  }, [_c('div', {
    staticClass: "mask"
  }), _vm._v(" "), _c('div', {
    staticClass: "dialog",
    staticStyle: {
      "top": "22.0009%"
    },
    attrs: {
      "id": "alert"
    }
  }, [_c('div', {
    staticClass: "dialog-con"
  }, [_vm._v("非常抱歉，您还未登陆，请先登录后查看")]), _vm._v(" "), _c('div', {
    staticClass: "dialog-btn",
    on: {
      "click": _vm.goBack
    }
  }, [_c('span', {
    staticClass: "sureBtn"
  }, [_vm._v("确认")])])])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-18f52f24", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-18f52f24","hasScoped":true}!./node_modules/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./app/component/jaddresscontent.vue
// module id = 284
// module chunks = 0